module.exports = __webpack_public_path__ + "img/miniapp_barcode.c6f41626.png";